import React, { useContext } from 'react'
import FmWonderKids from '../components/Public/FM/FmWonderKids'
import AddWonderKidsFB from '../components/Public/FM/templates/AddWonderKidsFB'
import StateContext from '../StateContext'

function FmPage() {

    const {loggedIn, userId} = useContext(StateContext)

    return (
        <div className="container my-4">
            <h2 className="my-3 font-weight-bold">Football Manager</h2>

            {loggedIn && userId === "aqX59RalZnV1sHLpS6UA1b5b4992" && <AddWonderKidsFB />}

            <FmWonderKids />
        </div>
    )
}
export default FmPage